import React from "react";
import { GET_LIST, Create, Toolbar, SaveButton, Title, Link, Button } from "react-admin";
import { Card, CardActions } from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import styled from "styled-components";
import moment_tz from "moment-timezone";
import {
  map,
  curry,
  range,
  filter,
  prop,
  isNil,
} from "ramda";
import LinearProgress from "@material-ui/core/LinearProgress";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ReactExport from "react-data-export";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const StyledTableCell = styled(TableCell)`
  white-space: nowrap;
`;

const styles = {
  container: {
    marginLeft: "0em",
    textAlign: "center",
  },
  rightAlignedCell: { textAlign: "right" },
  leftAlignedCell: { textAlign: "left" },
  boldCell: { fontWeight: "bold" },
  totalValues: { fontSize: "14", color: "C0C0C0" },
  values: { fontWeight: "normal", padding: "1rem"},
  tableMargin: { marginBottom: "2rem" },
  spaceEvenly: { display: "flex", flexFlow: "row", justifyContent: "space-evenly"}
};


let dataSet1 = [];

class reportToursChargeDetails extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      tourId: 0,
      tourTitle:"",
      loading: false,
      setLoading: false,
      exportData: [],
      setExportData: [],
      DataSet: [],
      totalValue: 0,
      totalRefunded: 0,
    };
  }

  async componentDidMount() {
    moment_tz.tz.setDefault("Europe/Madrid");
    const url = window.location.href;
    const parts = url.split("/");
    this.state.tourId = parts[parts.length - 1];
    await this.getDetails();
  }

  async getDetails() {
    const dataProvider = await dataProviderFactory("rest");
    const chargesReport = dataProvider(
      GET_LIST,
      "reports/reportToursCharges/" + this.state.tourId,
      {
        filter: {
          tourId: this.state.tourId,
        },

        pagination: {
          page: 1,
          perPage: 99999,
        },
        sort: { field: this.props.created_at, order: "DESC" },
      }
    );

    chargesReport
      .then((result) => {
        this.state.loading = false;
        dataSet1 = result.data;

        dataSet1.map((data) =>{
          this.state.totalValue += data.value;
          this.state.totalRefunded += data.refunded;
          this.state.tourTitle.length < 1 ? this.state.tourTitle = this.state.tourId + " "+ data.tourName : this.state.tourTitle;
        })
        const dataSet = [
          {
            columns: [
              {
                title: "Date",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 125 },
              }, // width in pixels
              {
                title: "Client",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 125 },
              }, // width in characters
              {
                title: "Value",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 125 },
              }, // width in pixels
              {
                title: "Refund",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 125 },
              }, // width in pixels
              {
                title: "Invoice url",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 200 },
              }, // width in pixels
            ],
            data: result.data.map((data) => [
              {
                value:
                  data.date != null
                    ? moment(data.date).format("DD/MM/YYYY")
                    : "",
                style: { font: { sz: "12" } },
              },
              {
                value: data.client != null ? data.client : "",
                style: { font: { sz: "12" } },
              },
              {
                value: data.value != null ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.value)
                : "",
                style: { font: { sz: "12" }, textAlign: { horizontal: 'right' } },
              },
              {
                value: data.refunded != null ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(data.refunded) 
                : "",
                alignment: { horizontal: 'bottom' },   
                style: { font: { sz: "12" } },   
              },
              {
                value: data.urlInvoice != null ? data.urlInvoice : "",
                //formula: `=HYPERLINK("${data.urlInvoice}", "Invoice ${data.idInvoice}")`,
                style: { font: { sz: "12" } },
              },
            ]),
          },
        ];

        this.setState({
          isLoading: false,
          loading: false,
          exportData: result.data,
          DataSet: dataSet,
        });
        return result.data;
      })
      .catch((error) => {
        this.state.loading = false;
      });
  }

  render() {
    const { isLoading, month } = this.state;

    const { classes, ...props } = this.props;

    if (isLoading) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }

    const PostCreateToolbar = (props) => (
      <Toolbar {...props} style={{ backgroundColor: "transparent" }}>
        <Button
          style={{ marginLeft: "10px" }}
          onClick={() => this.props.history.goBack()}
          label="Back"
        >
          <ArrowBackIcon />
        </Button>
        {this.state.exportData.length !== 0 ? (
          <ExcelFile
            filename={"Tour "+this.state.tourId+ " Charges"} 
            element={
              <SaveButton label="Download" style={{ marginLeft: "10px" }} />
            }
          >
            <ExcelSheet dataSet={this.state.DataSet} name="Charges" />
          </ExcelFile>
        ) : 
        null}
      </Toolbar>
    );

    return (
      <React.Fragment>
        <Title title={this.state.tourTitle} />
        <Card>
          <PostCreateToolbar />
          <Table style={styles.tableMargin}>
            <TableHead>
              <TableRow>
                <TableCell style={styles.rightAlignedCell}>Date</TableCell>
                <TableCell style={styles.leftAlignedCell}>Client</TableCell>
                <TableCell style={styles.leftAlignedCell}>Type</TableCell>
                <StyledTableCell style={styles.rightAlignedCell}>
                  Value
                </StyledTableCell>
                <StyledTableCell style={styles.rightAlignedCell}>
                  Refunded
                </StyledTableCell>
                <TableCell style={styles.rightAlignedCell}>Invoice url</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.exportData.length === 0 ? (
                this.state.loading ? (
                  <TableRow>
                    <TableCell colSpan={5}>
                      <LinearProgress />
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={5} style={styles.container}>
                      No results...
                    </TableCell>
                  </TableRow>
                )
              ) : null}
              {dataSet1.map((item) => (
                <TableRow key={item.chargeID}>
                  <StyledTableCell style={styles.rightAlignedCell}>
                    {moment(item.date).format("DD/MM/YYYY")}
                  </StyledTableCell>
                  <TableCell style={styles.leftAlignedCell}>
                    {item.client}
                  </TableCell>
                  <TableCell style={styles.leftAlignedCell}>
                    {item.type}
                  </TableCell>
                  <TableCell style={styles.rightAlignedCell}>
                    {new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(item.value)}
                  </TableCell>
                  <TableCell style={styles.rightAlignedCell}>
                    {new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(item.refunded)}
                  </TableCell>
                  <TableCell style={styles.rightAlignedCell}>
                    <a target="_blank" href={item.urlInvoice}>
                      Invoice ({item.idInvoice})
                    </a>
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell colSpan={2} />
                <TableCell style={styles.rightAlignedCell}>
                  <strong>Total:</strong> {new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.state.totalValue)}
                </TableCell>
                <TableCell style={styles.rightAlignedCell}>
                  <strong>Total:</strong> {new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.state.totalRefunded)}
                </TableCell>
                <TableCell />
              </TableRow>
            </TableBody>
          </Table>
        </Card>
      </React.Fragment>
    );
  }
}

export default reportToursChargeDetails;



// WEBPACK FOOTER //
// ./src/components/reportToursChargeDetails.js